export default "__VITE_ASSET__CkmR0L6T__"